// extracted by mini-css-extract-plugin
export default {"palettePrimaryMain":"#664de6","background":"#fff"};